import { SiOpenaigym } from "react-icons/si";

export const links = [
  {
    name: "Home",
    path: "/home",
  },
  {
    name: "About",
    path: "/about",
  },
  {
    name: "News",
    path: "/News",
  },
  {
    name: "Our Products",
    path: "/products",
  },
  {
    name: "Contact",
    path: "/contact",
  },
];

export const products = [
  {
    id: 1,
    icon: <SiOpenaigym />,
    title: "Pasta",
    info: "We product many types of pasta such as 'Thick Elbow' , 'Thin Elbow' and 'Fusilli', We can also produce any other type of pasta if requested from us.",
    path: "/products",
  },
  {
    id: 2,
    icon: <SiOpenaigym />,
    title: "Vermisilli",
    info: "Also we produce vermicelli with many sizes with high quality production",
    path: "/products",
  },
  {
    id: 3,
    icon: <SiOpenaigym />,
    title: "Spaghetti",
    info: "We will soon produce spaghetti also , in order to complete the package of short-cut and long-cut pasta",
    path: "/products",
  },
  {
    id: 4,
    icon: <SiOpenaigym />,
    title: "Another",
    info: "There are many products we are planing to produce them ",
    path: "/products",
  },
];

export const sliders = [
  {
    id: 1,
    photo: require("./images/picture1.png"),
  },
  {
    id: 2,
    photo: require("./images/picture2.png"),
  },
  {
    id: 3,
    photo: require("./images/picture3.png"),
  },
  {
    id: 4,
    photo: require("./images/picture4.png"),
  },
];
